(function () {
	let initializedSwipers = [];

	const shuffleSlides = (wrapper) => {
		if (!wrapper) return;
		const slides = Array.from(wrapper.children);
		for (let i = slides.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
			[slides[i], slides[j]] = [slides[j], slides[i]];
		}
		slides.forEach((slide) => wrapper.appendChild(slide));
	};

	const productSlider = () => {
		const productSliders = Array.from(document.querySelectorAll(".products-slider"));
		if (productSliders.length === 0) return;

		productSliders.forEach((slider) => {
			if (slider.classList.contains("slider_started")) return;

			slider.classList.add("slider_started");

			const sectionId = slider.dataset.id;
			const perRow = slider.dataset.perRow;
			const mobile = Number(slider.dataset.mobile) || 1;
			const speed = slider.dataset.speed * 1000;
			const delay = slider.dataset.delay * 1000;
			const autoplay = toBoolean(slider.dataset.autoplay);
			const stopAutoplay = toBoolean(slider.dataset.stopAutoplay);
			const showArrows = toBoolean(slider.dataset.showArrows);
			const randomize = toBoolean(slider.dataset.randomize);

			if (randomize) {
				shuffleSlides(slider.querySelector(".products-slider__swiper-wrapper"));
			}

			let autoplayParm = {};
			let arrowsParm = {};

			if (autoplay) {
				autoplayParm = {
					autoplay: {
						delay: delay,
						pauseOnMouseEnter: stopAutoplay,
						disableOnInteraction: false,
					},
				};
			}

			if (showArrows) {
				arrowsParm = {
					navigation: {
						nextEl: `#${sectionId} .swiper-button-next`,
						prevEl: `#${sectionId} .swiper-button-prev`,
					},
					pagination: {
						el: `#${sectionId} .swiper-pagination`,
						clickable: true,
					},
				};
			}

			let swiperParms = {
				speed: speed,
				keyboard: true,
				slidesPerView: mobile,
				breakpoints: {
					576: {
						slidesPerView: perRow >= 2 ? 2 : 1,
					},
					750: {
						slidesPerView: perRow >= 3 ? 3 : perRow,
					},
					990: {
						slidesPerView: perRow >= 4 ? 4 : perRow,
					},
					1150: {
						slidesPerView: perRow,
					},
				},
				mousewheel: {
					forceToAxis: true,
				},
				...arrowsParm,
				...autoplayParm,
			};

			const swiper = new Swiper(`#${sectionId} .swiper`, swiperParms);
			initializedSwipers.push(swiper);
		});
	};

	const adjustButtonPosition = (height) => {
		document.querySelectorAll(`.products-slider .swiper-button`).forEach((button) => {
			button.style.top = height / 2 + 20 + "px";
		});
	};

	const changePosition = () => {
		if (window.innerWidth < 1150) return;

		const image = document.querySelector(`.products-slider .media img`);
		if (image) {
			if (image.tagName === "IMG") {
				if (image.complete) {
					adjustButtonPosition(image.offsetHeight);
				} else {
					image.addEventListener("load", function () {
						adjustButtonPosition(this.offsetHeight);
					});
				}
			} else if (image.tagName === "svg") {
				const height = image.getBoundingClientRect().height;
				adjustButtonPosition(height);
			}
		}
	};

	const toBoolean = (string) => {
		return string === "true";
	};

	// Init product recommendations
	if (document.querySelector("product-recommendations") !== null) {
		const initslider = setInterval(() => {
			const swiperContainer = document
				.querySelector("product-recommendations")
				.querySelector(".swiper");

			if (swiperContainer !== null) {
				if (swiperContainer.classList.contains("swiper-initialized")) {
					clearInterval(initslider);
				}
				productSlider();
			}
		}, 100);
	}

	// DOM ready
	document.addEventListener("DOMContentLoaded", function () {
		productSlider();
		changePosition();

		document.addEventListener("shopify:section:load", function () {
			productSlider();
			changePosition();
		});
	});

	// Resize
	let resizeTimeout;
	window.addEventListener("resize", function () {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(() => {
			changePosition();
			productSlider();
		}, 200);
	});
})();
